import { atomFamily } from "jotai/utils";

import { InjuredPerson } from "types/DigitalJourneySession";

import { createDerivedSessionAtom } from "./utils/createDerivedSessionAtom";
import { createPersistedAtom } from "./utils/createPersistedAtom";

export const DEFAULT_INJURED_PERSON_DATA: InjuredPerson = {
  firstName: "",
  lastName: "",
  personalCode: "",
  role: null,
};

export const DEFAULT_INJURED_PERSONS: InjuredPerson[] = Array.from({ length: 5 }, () => DEFAULT_INJURED_PERSON_DATA);

export const sessionInjuredPersonsAtom = atomFamily((sessionId: string) =>
  createPersistedAtom(`injuredPersons-${sessionId}`, DEFAULT_INJURED_PERSONS)
);
export const injuredPersonsAtom = createDerivedSessionAtom<InjuredPerson[]>(sessionInjuredPersonsAtom);
